import {combineReducers} from "redux";
import {reducer as formReducer} from 'redux-form';
import {routerReducer} from "react-router-redux";

export default combineReducers({
    router: routerReducer,
    form: formReducer
})


// WEBPACK FOOTER //
// ./src/reducer.js